/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performDisputeResolutionObj: {},
  selectedPlanType: '',
  planType: [],
  rebateProgram: [],
  errorMsgCurrent: [],
  rebateProgramName: {},
  quarterFrom: '',
  invoiceComparison: [],
  displayObj: {
    rebateProgramName: {},
    quarterFrom: '',
    invoiceComparison: [],
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPLAY_OBJ_CURRENT:
      return { ...state, performResolutionObj: action.screenData };

    case actionTypes.GET_ERROR_MSG_CURRENT:
      return { ...state, errorMsgCurrent: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_CURRENT:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_CURRENT:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_FROM_CURRENT:
      return { ...state, quarterFrom: action.payload };

    case actionTypes.GET_REBATE_PROGRAM_NAME_CURRENT:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.GET_INVOICE_COMPARISON:
      let displayObj = {
        ...state.displayObj,
        invoiceComparison: action.payload,
      };
      return { ...state, invoiceComparison: action.payload, displayObj };
    // return { ...state, invoiceComparison: action.payload };
    case actionTypes.SET_DISPLAY_OBJ_CURRENT:
      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.SET_REFRESH_DATA_CURRENT:
      return {
        ...state,
        performDisputeResolutionObj: {},
        selectedPlanType: '',
        planType: [],
        rebateProgram: [],
        errorMsgCurrent: [],
        rebateProgramName: {},
        quarterFrom: '',
      };
    case actionTypes.REFRESH_DATA_CURRENT_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};
export default reducer;
